import { Controller } from "@hotwired/stimulus"

// Thin bridge: collects photo data from the report detail DOM
// and delegates to the shared photo-lightbox controller.
// A report's video tiles are links to the video (K9-6): with the viewer on
// the page it opens there instead; without it, the link just opens.
export default class extends Controller {
  open(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    const photos = JSON.parse(this.element.dataset.photos || "[]")
    if (!photos.length) return

    const lightbox = this._getLightbox()
    if (!lightbox) return
    event.preventDefault()
    lightbox.open({ photos, index })
  }

  _getLightbox() {
    const el = document.querySelector('[data-controller~="photo-lightbox"]')
    return el
      ? this.application.getControllerForElementAndIdentifier(el, "photo-lightbox")
      : null
  }
}
